import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {Router} from "@angular/router";
import {SubscriptionCheckService} from "./services/subscription-check.service";
import {ProfileMessage} from "../../_services/profile.message";
import {AuthService} from "../login/services/auth.service";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-subscription-check',
    templateUrl: './subscription-check.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SubscriptionCheckComponent implements OnInit {

    message = 'Loading your dashboard...';
    constructor(
        private svc: SubscriptionCheckService,
        private msg: ProfileMessage,
        private authService: AuthService,
        private router: Router
    ) {
    }

    async ngOnInit(): Promise<void> {
        this.logic();
    }

    logic() {
        this.svc.verify().then(ry => {
            switch (ry.result) {

                case '03':
                case '04':
                case '06': {
                    setTimeout(() => {
                        this.router.navigate(['/billing']).then();
                    }, 2000);
                    break;
                }
                case '01':
                case '02':
                case '05':
                case '07':
                case '08': {
                    this.authService.profile().then(sr => {
                        console.log(ry.result)
                        this.msg.changeMessage(sr);
                        window.location.href = environment.home + '/#/dashboard';
                    })

                    break;
                }
                case '100': {
                    console.log('100');
                    this.authService.profile().then(sr => {
                        this.msg.changeMessage(sr);
                        window.location.href = environment.home + '/#/office/office-dashboard';
                    })
                    break;
                }
                default: {

                    setTimeout(() => {
                        this.router.navigate(['/login']).then();
                    }, 2000);
                    break;
                }
            }
        })
    }

}
